<common-simple-search class="d-lg-none"></common-simple-search>
<button class="d-lg-none btn pl-1 br-0 d-flex align-items-center justify-content-center" *ngIf="hasHistory" (click)="goBack()">
  <i class="text-green mr-2 icon-arrow-left"></i> Back to results
</button>
<div class="machine-details-container" *ngIf="machine">
  <common-image-gallery [images]="machine.images"></common-image-gallery>

  <div class="container special-container">
    <div
      class="alert alert-warning d-md-flex justify-content-between mt-3"
      role="alert"
      *ngIf="
        (machine.status != 'Available' && machine.status != 'Onboarding') ||
        (machine.approvalStatus != 'Approved' && machine.approvalStatus != null) ||
        machine.rentalRate == 0
      "
    >
      <div>{{ machine.make }} {{ machine.model }} is not available.</div>
      <a class="text-underline cursor-pointer" [routerLink]="['/equipment-rentals']" [queryParams]="{ primaryType: machine.primaryType }"
        >View similar machines</a
      >
    </div>
    <div class="row mt-4">
      <div class="col-xl-6 offset-xl-0">
        <app-machine-summary [machine]="machine" [numberOfReviews]="numberOfReviews"></app-machine-summary>

        <ng-container *ngIf="machine.description.length">
          <h4 class="subhead-1 section-title">Description</h4>
          <common-read-more-text [text]="machine.description" class="machine-description mb-3" maxLength="300"></common-read-more-text>
          <div class="bb-light"></div>
        </ng-container>

        <a
          target="_blank"
          href="https://share.hsforms.com/1SWnQlTcBSNqIsYOqawqPWAc9pim?year={{ machine.year }}&make={{ machine.make }}&model={{ machine.model }}&rubbl_id={{
            machine.id
          }}"
          *ngIf="machine.buyItNowEnabled"
          class="d-flex d-xl-none btn btn-outline-dark align-items-center justify-content-center w-100 py-3 mb-4"
        >
          <i class="icon-earnings fs-30 text-primary mr-2"></i>
          <div class="fs-24 teko">Buy it Now for {{ machine.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}</div>
        </a>

        <!-- Attachments -->
        <ng-container *ngIf="fixedAttachments.length || nonFixedAttachments.length">
          <p class="section-header">Attachments</p>
          <div class="d-block d-lg-flex">
            <!-- Fixed Attachments Section -->
            <div class="mr-3 w-50 fs-115" *ngIf="fixedAttachments.length">
              <p>Currently Configured</p>
              <div class="mt-2 list-group">
                <div class="flex-column align-items-start" [class.mb-3]="!isLast" *ngFor="let attachment of fixedAttachments; last as isLast">
                  <div class="mb-0 font-weight-light">
                    {{ attachment.displayName }}
                  </div>
                  <small class="text-muted">{{ attachment.description }}</small>
                  <div class="mt-2 d-flex flex-column align-items-start">
                    <span *ngIf="attachment.cost !== -1" class="badge badge-pill badge-primary badge-attachment">
                      Monthly Rental Rate: {{ attachment.cost | currency: "USD":"symbol":"1.0-0" }}
                    </span>
                    <span *ngIf="attachment.rpoEnabled" class="badge badge-pill badge-primary badge-attachment">
                      Rent To Own Price: {{ attachment.purchasePrice | currency: "USD":"symbol":"1.0-0" }}
                    </span>
                    <span *ngIf="attachment.buyItNowPrice" class="badge badge-pill badge-primary badge-attachment">
                      Buy It Now Price: {{ attachment.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Non-Fixed Attachments Section -->
            <div class="w-50 fs-115" [class.ml-lg-3]="fixedAttachments.length" *ngIf="nonFixedAttachments.length">
              <p>Available</p>
              <div class="mt-2 list-group">
                <div class="flex-column align-items-start" [class.mb-3]="!isLast" *ngFor="let attachment of nonFixedAttachments; last as isLast">
                  <div class="mb-0 font-weight-light fs-115">{{ attachment.displayName }}</div>
                  <small class="text-muted">{{ attachment.description }}</small>
                  <div class="mt-2 d-flex flex-column align-items-start">
                    <span *ngIf="attachment.cost !== -1" class="badge badge-pill badge-primary badge-attachment">
                      Monthly Rental Rate: {{ attachment.cost | currency: "USD":"symbol":"1.0-0" }}
                    </span>
                    <span *ngIf="attachment.rpoEnabled" class="badge badge-pill badge-primary badge-attachment">
                      Rent To Own Price: {{ attachment.purchasePrice | currency: "USD":"symbol":"1.0-0" }}
                    </span>
                    <span *ngIf="attachment.buyItNowPrice" class="badge badge-pill badge-primary badge-attachment">
                      Buy It Now Price: {{ attachment.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="machine.rpoEnabled">
          <common-machine-rpo-table [machine]="machine"></common-machine-rpo-table>
          <div class="bb-light"></div>
        </ng-container>

        <app-machine-reviews [machine]="machine"></app-machine-reviews>
        <div class="bb-light"></div>

        <common-things-to-know-section [buyItNowOnly]="machine.buyItNowOnly"></common-things-to-know-section>
        <div class="bb-light"></div>

        <ng-container *ngIf="!machine.buyItNowOnly">
          <common-services-card [showLearnMoreForAll]="true"></common-services-card>
          <div id="rubbl-services-anchor" name="rubbl-services-anchor"></div>
          <div class="bb-light mt-0"></div>
        </ng-container>
        <ng-container *ngIf="machine.specifications.length">
          <app-machine-specs [specifications]="machine.specifications"></app-machine-specs>
          <div class="bb-light"></div>
        </ng-container>
        <app-machine-specs [machine]="machine"></app-machine-specs>
        <!-- <div class="bb-light"></div>
        <app-machine-location [location]="machine.location"></app-machine-location> -->
      </div>
      <div class="d-none d-xl-block col-lg-5 col-xl-5 offset-lg-1" *ngIf="windowSize !== 'mobile' && windowSize !== 'tablet' && windowSize !== 'desktop'">
        <ng-container *ngIf="cartItem">
          <ng-container *ngIf="!machine.buyItNowOnly">
            <div class="card mb-3" id="add-to-cart-details">
              <div class="card-body">
                <common-add-to-cart-details
                  [cartItem]="cartItem"
                  [inCheckout]="true"
                  [onMachineDetails]="true"
                  [isEstimate]="isEstimate"
                  (edit)="editCartItem($event)"
                  (addToCart)="addToCart()"
                ></common-add-to-cart-details>
              </div>
            </div>
          </ng-container>

          <div class="card sticky-that-shit">
            <div class="card-body">
              <ng-container *ngIf="isEstimate">
                <ng-container *ngIf="!machine.buyItNowOnly">
                  <button
                    type="button"
                    rt="add-to-cart-button"
                    class="btn btn-lg btn-block btn-no-box-shadow btn-primary"
                    [disabled]="
                      (machine.status != 'Available' && machine.status != 'Onboarding') ||
                      (machine.approvalStatus != 'Approved' && machine.approvalStatus != null) ||
                      machine.rentalRate == 0
                    "
                    (click)="addToCart()"
                  >
                    Book Now
                  </button>
                </ng-container>
                <ng-container *ngIf="machine.buyItNowEnabled">
                  <ng-container *ngIf="!machine.buyItNowOnly">
                    <div class="side-headings call-out-text py-3">OR</div>
                  </ng-container>
                  <a
                    target="_blank"
                    href="https://share.hsforms.com/1SWnQlTcBSNqIsYOqawqPWAc9pim?year={{ machine.year }}&make={{ machine.make }}&model={{
                      machine.model
                    }}&rubbl_id={{ machine.id }}"
                    class="d-flex btn btn-outline-dark align-items-center justify-content-center w-100 py-3"
                  >
                    <i class="icon-earnings fs-30 text-primary mr-2"></i>
                    <div class="fs-24 teko">Buy it Now for {{ machine.buyItNowPrice | currency: "USD":"symbol":"1.0-0" }}</div>
                  </a>
                </ng-container>

                <div id="help-text" class="supporting-text text-grey text-center mt-3">
                  Want to book by phone? Please call us at <a href="tel:(866) 455-8531">(866) 455-8531</a>.
                </div>
                <div class="bb-light my-3"></div>
                <button type="button" class="btn btn-lg btn-block btn-outline-secondary btn-no-box-shadow mt-3" (click)="share()">
                  <i class="icon-share text-primary fs-22"></i> Share
                </button>
              </ng-container>
              <ng-container *ngIf="!isEstimate">
                <button type="button" rt="add-to-cart-button" class="btn btn-lg btn-block btn-no-box-shadow btn-primary" (click)="editCartItem(cartItem)">
                  Edit
                </button>
                <div id="help-text" class="supporting-text text-grey text-center mt-3">Machine is in your cart</div>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!cartItem">
          <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '50px', 'margin-bottom': '20px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px', 'margin-bottom': '20px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px', 'margin-bottom': '20px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px', 'margin-bottom': '20px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px', 'margin-bottom': '20px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '75px', 'margin-bottom': '20px' }"></ngx-skeleton-loader>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="container mt-5">
    <app-machines-from-owner-carousel [accountId]="machine.accountId" [machineIdsToExclude]="[machine.id]"></app-machines-from-owner-carousel>
    <app-machines-in-area-carousel
      [area]="machine.location.address | address: 'cityState'"
      [longitude]="machine.location.longitude"
      [latitude]="machine.location.latitude"
      [machineIdsToExclude]="[machine.id]"
    ></app-machines-in-area-carousel>
  </div>

  <app-add-to-cart-footer
    *ngIf="(windowSize === 'mobile' || windowSize === 'tablet' || windowSize === 'desktop') && cartItem"
    [machine]="machine"
    [cartItem]="cartItem"
    [machineInCart]="!isEstimate"
  ></app-add-to-cart-footer>
</div>

<common-footer></common-footer>
